import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "reports" }
const _hoisted_2 = { class: "opts" }
const _hoisted_3 = { class: "col calendar" }
const _hoisted_4 = {
  key: 0,
  class: "date-range"
}
const _hoisted_5 = {
  key: 1,
  class: "date-range required"
}
const _hoisted_6 = { class: "multiselect-row" }
const _hoisted_7 = { class: "multiselect-row" }
const _hoisted_8 = { class: "multiselect-row" }
const _hoisted_9 = { class: "col" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DropdownCalendar = _resolveComponent("DropdownCalendar")
  const _component_el_input_tag = _resolveComponent("el-input-tag")
  const _component_el_select_v2 = _resolveComponent("el-select-v2")
  const _component_Button = _resolveComponent("Button")
  const _component_el_upload = _resolveComponent("el-upload")
  const _component_Divider = _resolveComponent("Divider")
  const _component_TasksRunner = _resolveComponent("TasksRunner")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TasksRunner, {
      class: "report",
      "can-run": $options.can_run,
      "runner-id": "adm_usage_reports",
      caption: "Usage Reports",
      runner: (tasks) => $options.runUsageReports(tasks, 'users')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_DropdownCalendar, {
              modelValue: $data.filter_dates,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.filter_dates) = $event)),
              "filter-indicator": false,
              title: "Date Range",
              "min-date": $options.min_date
            }, null, 8 /* PROPS */, ["modelValue", "min-date"]),
            (!!$data.filter_dates.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($options.date), 1 /* TEXT */))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, " Select date range "))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_input_tag, {
              modelValue: $data.excluded_email_domains,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.excluded_email_domains) = $event)),
              placeholder: "Excluded Email Domains (e.g. example.com)"
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_el_input_tag, {
              modelValue: $data.excluded_user_emails,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.excluded_user_emails) = $event)),
              placeholder: "Excluded User Emails (max@genrate.ai)"
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_el_select_v2, {
              modelValue: $data.selected_metrics,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.selected_metrics) = $event)),
              class: _normalizeClass(["metrics", {empty: !$data.selected_metrics.length}]),
              "popper-class": "metrics-popper",
              options: $data.metric_items,
              placeholder: "Select metrics",
              multiple: "",
              teleported: false
            }, null, 8 /* PROPS */, ["modelValue", "class", "options"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_el_upload, {
              ref: "csv_file",
              "file-list": $data.filelist,
              "onUpdate:fileList": _cache[4] || (_cache[4] = $event => (($data.filelist) = $event)),
              class: "upload-csv",
              "on-exceed": $options.handleExceed,
              limit: 1,
              "auto-upload": false,
              accept: ".csv",
              "on-change": $options.onFileChange
            }, {
              trigger: _withCtx(() => [
                _createVNode(_component_Button, { class: "attach-button" }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createTextVNode(" Attach work titles csv ")
                  ])),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["file-list", "on-exceed", "on-change"])
          ]),
          _createVNode(_component_Divider)
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["can-run", "runner"])
  ]))
}